<template>
  <div
    :class="[isImageModalShown ?'d-none':'' ]"
    class="image-modal-wrapper position-fixed align-items-center justify-content-center d-flex position-fixed">
    <div class="modal-inner  align-items-center justify-content-center d-flex">
      <div class="bm-image-modal-content  bg-white px-24 pt-24  pb-26 position-fixed rounded rounded-4 scroller w-100 h-100">
        <div
          class="p-0 border-0 text-end close-icon-wrapper custom-icon"
          @click="handleModalClose">
          <icon name="close-icon"/>
        </div>
        <div class="bm-modal-body border-0 mt-3">
          <h2 class="text-center modal-heading text-dark-gray fs-24  mb-0">Add Image</h2>
          <div class="tabs-wrapper">
            <div class="tabs-inner  ">
              <ul class="list-unstyled display-grid mb-0 mt-18">
                <li>
                  <tab
                    :id="3"
                    :tab-active="selectedId"
                    title="Stock photos"/>
                </li>

                <li class="">
                  <tab
                    :id="2"
                    :tab-active="selectedId"
                    title="My computer"/>
                </li>
                <li class="">
                  <tab
                    :id="1"
                    :tab-active="selectedId"
                    title="My gallery"/>
                </li>
              </ul>
            </div>

            <div class="main-tabs-content mt-20">
              <div
                v-if="selectedId == 1">
                <thumbnail-box
                  ref="galleryThumbnailBox"
                  :image-data="selectedImageData"
                  :images="getMyGalleryImages"
                  :loader="getLoaderState"
                  gallery-images="gallery"/>
              </div>
              <div
                v-show="selectedId == 2"
                class="file-select px-16 ">
                <file-select

                  class="px-16"/>
              </div>
              <div v-if="selectedId == 3" >
                <thumbnail-box
                  ref="stockThumbnailBox"
                  :image-data="selectedImageData"
                  :images="MyStockImages"
                  :loader="getLoaderState"
                  @resetStockPhotosAfterSearch="resetStockPhotosAfterSearch"
                  @searchStockPhotos="fetchStockPhotosByKeyWord"
                />
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <div
      :class="[isImageModalShown?'d-none':'' ]"
      class="backdrop position-fixed h-100 w-100"
      @click="handleModalClose"/>
  </div>
</template>
<script>

import ThumbnailBox from '@/components/ThumbnailBox/ThumbnailBox.vue';
import FileSelect from '@/components/FileSelect/FileSelect.vue';
import StockImages from '@/components/StockImages/StockImages.vue';
import Tab from '@/components/Tab/Tab.vue';
import EventBus from '@/EventBus';
import { mapGetters } from 'vuex';
import ApplicationEventTypes from '../../mixins/ApplicationEventTypes';


export default {
  name:       'ImageModal',
  components: {
    tab:             Tab,
    'thumbnail-box': ThumbnailBox,
    'file-select':   FileSelect,
    'stock-images':  StockImages,
  },
  data() {
    return {
      isImageModalShown: false,
      isTabClicked:      false,
      loaderToggle:      true,
      selectedId:        '3',
      isGalleryShown:    false,
      selectedImageData: {},
      MyGalleryImages:   [],
      MyStockImages:     [],
      stockImages:       {
        MaxLimit:                  20,
        LowLimit:                  0,
        isStockImagesSearchByWord: false,
        isStockImagesByDefault:    true,
        isProcessing:              false,
      },
      // stockImagesLimit:20,
      myGalleryImages:
                    {
                      MaxLimit:     20,
                      LowLimit:     0,
                      isProcessing: false,
                    },
    };
  },
  mounted() {
    if (window.screen.height > 1500 && window.screen.height <= 3000) {
      this.stockImages.MaxLimit = this.myGalleryImages.MaxLimit = 40;
    }

    if (window.screen.height > 3000 && window.screen.height <= 4500) {
      this.stockImages.MaxLimit = this.myGalleryImages.MaxLimit = 60;
    }

    if (window.screen.height > 4500) {
      this.stockImages.MaxLimit = this.myGalleryImages.MaxLimit = 80;
    }

    // code For lazy loading in Stock Images

    // code for Lazy loading in Gallery Images

    setTimeout(() => {
      this.fetchMyGalleryList();
      this.bindScrollToGalleryImages();
    }, 0);
    setTimeout(() => {
      this.fetchStockList();
    }, 0);
    EventBus.$on('AddImageNewImageToMyGalleryImages', imageData => this.MyGalleryImages.unshift(imageData));
    EventBus.$on('ondeleteImageFromMyGallary', this.deleteImageFromGallary),
    EventBus.$on('onImageSelected', (data, mood) => {
      this.selectedImageData = data;
      this.selectingImageForLefPanel();
    });

    EventBus.$on('toggleTabs', this.handleTabClick);
    EventBus.$on('AddNewImageOnCanvas', this.onAddNewImageOnCanvas);
  },
  beforeDestroy() {
    EventBus.$off('onImageSelected');
    EventBus.$off('AddNewImageOnCanvas', this.onAddNewImageOnCanvas);
  },
  methods: {

    onAddNewImageOnCanvas(imageData) {
      this.selectedImageData = imageData;
      this.selectingImageForLefPanel();
    },
    deleteImageFromGallary(imageId) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);

      const bankId    = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
      const userId    = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=DeleteImageFromGallery&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&id=${imageId}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', this.deleteImageFromMyGallaryArrayList(imageId));
      oReq.addEventListener('error', (e) => {
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    selectingImageForLefPanel() {
      if (this.isAddNewImageModal === true) {
        Object.keys(this.selectedImageData).length !== 0 && EventBus.$emit('onAddingNewObjectImage', this.selectedImageData) && this.$store.commit('toggleIsAddNewImageModal');
        Object.keys(this.selectedImageData).length === 0 && alert('Please Select a Image');
        return;
      }
      Object.keys(this.selectedImageData).length !== 0 && EventBus.$emit(ApplicationEventTypes.ImageObjectEvents.SELECTED_IMAGE_FOR_LEFT_PANEL, this.selectedImageData) && this.handleModalClose();
      Object.keys(this.selectedImageData).length == 0 && alert('Please Select a Image');
    },
    handleTabClick(id) {
      this.selectedId = id;
    },
    handleModalClose() {
      this.$store.commit('setIsAddNewImageModal', false);
      this.$store.commit('setImageModel', false);
      this.isImageModalShown = !this.isImageModalShown;
    },
    clearValue() {
      this.query     = '';
      this.isFocused = false;
    },

    typeFocus() {
      if (this.query.length > 0) {
        this.isFocused = true;
      } else {
        this.isFocused = false;
      }
    },

    removeFocus() {
      this.isFocused = false;
    },

    focusIn() {
      this.isFocusedOut = true;
    },

    fetchMyGalleryList() {
      if (this.myGalleryImages.MaxLimit != this.myGalleryImages.LowLimit) {
        this.makeLoaderVisible();
        this.myGalleryImages.isProcessing = true;
        const urlSearchPart               = window.location.search;
        const newUrlSearchParams          = new URLSearchParams(urlSearchPart);

        const bankId = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
        const userId = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';

        const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
        const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetMyGalleryImagesInfoNewEditor&domainURL=https://${domainUrl}.com/&bankId=${bankId}&userId=${userId}&maximumRows=${this.myGalleryImages.MaxLimit}&startRowIndex=${this.myGalleryImages.LowLimit}`;

        const oReq = new XMLHttpRequest();
        oReq.addEventListener('load', this.loadMyGalleryImages);
        oReq.addEventListener('error', (e) => {
          this.MyGalleryImages              = [0];
          this.myGalleryImages.isProcessing = false;
          this.makeLoaderInVisible();
          console.error(e);
        });
        oReq.open('GET', url);
        oReq.send();
      }
    },
    fetchStockList() {
      if (this.stockImages.MaxLimit != this.stockImages.LowLimit && !this.stockImages.isStockImagesSearchByWord) {
        this.makeLoaderVisible();
        this.stockImages.isProcessing = true;
        const urlSearchPart           = window.location.search;
        const newUrlSearchParams      = new URLSearchParams(urlSearchPart);
        const bankId                  = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
        const domainUrl               = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
        const url                     = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetStockImagesPagedNewEditor&domainURL=https://${domainUrl}.com/&bankId=${bankId}&maximumRows=${this.stockImages.MaxLimit}&startRowIndex=${this.stockImages.LowLimit}`;


        const oReq  = new XMLHttpRequest();
        const _this = this;
        oReq.addEventListener('load', this.loadStockImages);
        oReq.addEventListener('error', (e) => {
          this.stockImages.isProcessing = false;
          this.loadStockImagesOffline(_this.$stockImages);
          this.makeLoaderInVisible();
          console.error(e);
        });
        oReq.open('GET', url);
        oReq.send();
      }
    },
    fetchStockPhotosByKeyWord(data) {
      this.makeLoaderVisible();
      this.stockImages.isStockImagesSearchByWord = true;
      this.stockImages.isStockImagesByDefault    = false;
      const urlSearchPart                        = window.location.search;
      const newUrlSearchParams                   = new URLSearchParams(urlSearchPart);
      const bankId                               = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
      const domainUrl                            = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url                                  = `${this.$store.getters.getBaseUrl}/newBMC/web_service.aspx?method=SearchImagesByKeywordForBankNewEditor&domainURL=https://${domainUrl}.com/&bankId=${bankId}&keyword=${data}`;


      const oReq  = new XMLHttpRequest();
      const _this = this;
      oReq.addEventListener('load', this.responStockPhotosByKeyWord);
      oReq.addEventListener('error', (e) => {
        this.makeLoaderInVisible();
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    responStockPhotosByKeyWord(data) {
      this.makeLoaderInVisible();
      const parser           = new DOMParser();
      const xmlParsed        = parser.parseFromString(data.target.response, 'text/xml');
      const imagesCollection = xmlParsed.getElementsByTagName('SearchImagesByKeywordForBankNewEditorResult')[0].innerHTML;
      this.MyStockImages     = JSON.parse(imagesCollection);
    },
    resetStockPhotosAfterSearch() {
      this.stockImages.isStockImagesSearchByWord = false;
      if (!this.stockImages.isStockImagesByDefault) {
        this.MyStockImages = [];
        this.fetchStockList();
      }
      this.stockImages.isStockImagesByDefault = true;
    },
    makeLoaderVisible() {
      this.loaderToggle = true;
    },
    makeLoaderInVisible() {
      this.loaderToggle = false;
    },
    loadMyGalleryImages(data) {
      try {
        const parser    = new DOMParser();
        const xmlParsed = parser.parseFromString(data.target.response, 'text/xml');
        console.log('xmlParsed');
        console.log(xmlParsed);
        let imagesCollection = xmlParsed.getElementsByTagName('GetMyGalleryImagesInfoNewEditorResult');
        imagesCollection     = JSON.parse(imagesCollection[0].innerHTML);
        if (this.myGalleryImages.MaxLimit < imagesCollection.nrTotal) {
          this.myGalleryImages.LowLimit  = this.myGalleryImages.MaxLimit;
          this.myGalleryImages.MaxLimit += 20;
        } else {
          this.myGalleryImages.MaxLimit = imagesCollection.nrTotal;
        }
        if (this.MyGalleryImages.length != imagesCollection.nrTotal) {
          this.MyGalleryImages = [...this.MyGalleryImages, ...imagesCollection.list];
        } else { // condition for checking the all total number of the image is called and there is no more api call needed
          this.myGalleryImages.LowLimit = 0;
          this.myGalleryImages.MaxLimit = 0;
        }
      } catch (e) {
        this.MyGalleryImages = [0];
        console.log('Error:loadMyGalleryImages/parseFromXml', e.message);
      } finally {
        this.myGalleryImages.isProcessing = false;
        this.makeLoaderInVisible();
      }
    },
    deleteImageFromMyGallaryArrayList(imgId) {
      const removeIndex = this.MyGalleryImages.findIndex((cur, index) => cur.Id == imgId);
      this.MyGalleryImages.splice(removeIndex, 1);
    },
    loadStockImages(data) {
      try {
        const parser              = new DOMParser();
        const xmlParsed           = parser.parseFromString(data.target.response, 'text/xml');
        let imagesCollection      = xmlParsed.getElementsByTagName('GetStockImagesPagedNewEditorResult');
        const totalNumberofImages = xmlParsed.getElementsByTagName('nrTotal')[0].innerHTML;
        imagesCollection[0] && (imagesCollection = imagesCollection[0].innerHTML);
        if (this.stockImages.MaxLimit < totalNumberofImages) {
          this.stockImages.LowLimit  = this.stockImages.MaxLimit;
          this.stockImages.MaxLimit += 20;
        } else {
          this.myGalleryImages.MaxLimit = totalNumberofImages;
        }
        if (this.MyGalleryImages.length != totalNumberofImages) {
          this.MyStockImages = [...this.MyStockImages, ...JSON.parse(imagesCollection)];
        } else { // conditon that tell the total number of images is called and there is no more api call needed
          this.stockImages.MaxLimit = 0;
          this.stockImages.LowLimit = 0;
        }
      } catch (e) {
        console.log('Error:loadStockImages/parseFromXml', e.message);
      } finally {
        this.stockImages.isProcessing = false;
        this.makeLoaderInVisible();
      }
    },
    loadStockImagesOffline(data) {
      try {
        // const parser = new DOMParser();
        // const xmlParsed = parser.parseFromString(data, 'text/xml');
        const imagesCollection    = data;
        const totalNumberofImages = 20;
        // imagesCollection[0] && (imagesCollection = imagesCollection[0].innerHTML);
        if (this.stockImages.MaxLimit < totalNumberofImages) {
          this.stockImages.LowLimit  = this.stockImages.MaxLimit;
          this.stockImages.MaxLimit += 20;
        } else {
          this.myGalleryImages.MaxLimit = totalNumberofImages;
        }
        if (this.MyGalleryImages.length != totalNumberofImages) {
          this.MyStockImages = JSON.parse(imagesCollection);
        } else { // conditon that tell the total number of images is called and there is no more api call needed
          this.stockImages.MaxLimit = 0;
          this.stockImages.LowLimit = 0;
        }
      } catch (e) {
        console.log('Error:loadStockImages/parseFromXml', e.message);
      } finally {
        this.makeLoaderInVisible();
      }
    },
    parseFromXml(data, tagName) {
      const parser           = new DOMParser();
      const xmlParsed        = parser.parseFromString(data, 'text/xml');
      const ImagesCollection = xmlParsed.getElementsByTagName(tagName);

      const imageArr = [];
      for (let collectionIndex = 0; collectionIndex < ImagesCollection.length; collectionIndex++) {
        const image       = ImagesCollection[collectionIndex];
        const imageObject = {};
        for (let imageKey = 0; imageKey < image.childElementCount; imageKey++) {
          imageObject[image.childNodes[imageKey].tagName] = image.childNodes[imageKey].innerHTML;
        }

        imageArr.push(imageObject);
      }
      return imageArr;
    },
    bindScrollToStockImages() {
      const stockImages = document.getElementById('stock-images');
      if (!stockImages) { return; }
      stockImages.onscroll = null;
      stockImages.addEventListener('scroll', () => {
        if (!this.stockImages.isProcessing && Math.round(stockImages.scrollTop + stockImages.clientHeight) >= stockImages.scrollHeight - 10) {
          this.fetchStockList();
        }
      });
    },
    bindScrollToGalleryImages() {
      const galleryImages = document.getElementById('gallery-images');
      if (!galleryImages) { return; }
      galleryImages.onscroll = null;
      galleryImages.addEventListener('scroll', () => {
        if (!this.myGalleryImages.isProcessing && Math.round(galleryImages.scrollTop + galleryImages.clientHeight) >= galleryImages.scrollHeight - 10) {
          this.fetchMyGalleryList();
        }
      });
    },
  },
  computed: {
    ...mapGetters({ isAddNewImageModal: 'getIsAddNewImageModal' }),
    getLoaderState() {
      return this.loaderToggle;
    },
    getMyGalleryImages() {
      return this.MyGalleryImages;
    },
  },
  updated() {
    if (this.selectedId == 3 || this.selectedId == 1) {
      if (this.selectedId == 3) {
        this.bindScrollToStockImages();
      } else if (this.selectedId == 1) {
        this.bindScrollToGalleryImages();
      }
    }
  },
};

</script>
<style lang="scss">
    .image-modal-wrapper {
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 4000;
      .bm-image-modal-content {
        min-width: 600px;
        height: calc(100vh - 40px) !important;
        //height: fit-content !important;
        width: 70vw !important;
        box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
        z-index: 99;
      }
        .bm-modal-content {
            min-width: 600px;
            height: fit-content !important;
            width: 70vw !important;
            box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
            z-index: 99;
        }

        .display-grid {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
        }

        .action-btn {
            min-width: 100px;
        }

        .modal-heading {
            font-weight: 600;
            line-height: 32px;
        }


        .search-bar-wrapper {
            min-width: 432px;
            max-width: none !important;
        }

        .bm-input {
            /*width: 100%;*/
            box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.08);
        }


        .images-thumbnail-wrapper {
            max-height: 356px;
            overflow-y: auto;
            display: flex;
            flex-flow: column wrap;

            &::-webkit-scrollbar {
                width: 8px;
                //margin-right: 4px;
                background-color: $grey10;
                border: 1px solid $grey20;
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb {
                box-shadow: inset 0px 0px 5px #dddddd;
                border: none;
                border-right: 2.5px solid transparent;
                border-left: 2.5px solid transparent;
                background: transparent;
            }
        }

        .backdrop {
            background-color: rgba(237, 237, 237, 0.6);
            filter: blur(4px);
            top: 0;
            left: 0;
            z-index: 0;
        }

        .search-icon {
            left: 14px;
            top: 11px;
        }

        .close-icon {
            right: 10px;
            top: 10px;
        }

        .browse-btn {
            min-width: 125px;
        }

        .select-file-computer {
            min-height: 412px;
            border-style: dashed !important;

            .file-upload-btn {
                input {
                    opacity: 0;
                    cursor: pointer;
                    left: 0;
                    top: 0;
                }
            }
        }

        .btn-close {
            height: 16px;
            width: 16px;
            outline: 0px;

            &:focus {
                outline: 0px;
            }
        }

        .bm-modal-footer {
            margin: 0 auto;
        }

        .focused {
            .bm-input {
                border-color: $blue50 !important;
                color: $grey80;
            }

            .close-icon {
                display: block !important;
            }

            .search-icon {
                svg {
                    path {
                        stroke: #3BB0FA;
                    }
                }
            }
        }

        .remove-focus {
            &.close-icon {
                display: block !important;
            }
        }

        .remove-focus {
            &.bm-input {
                border: 1px solid #EDEDED;
            }
        }

        .bm-input {
            &:focus + {
                .search-icon {
                    svg {
                        path {
                            stroke: #3BB0FA;
                        }
                    }
                }
            }
        }

        .active-search {
            .icon {
                svg {
                    path {
                        stroke: #3BB0FA;
                    }
                }
            }
        }

        .remove-focus {
            .icon {
                svg {
                    filter: none;
                }
            }
        }
      .file-select{
        min-height: calc(100vh - 244px);
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .close-icon-wrapper {
        .icon {
            display: inline-flex !important;
            cursor: pointer;
        }
    }


</style>
